import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "competitor-price-ignore" },
    [
      _c(
        VContainer,
        { staticClass: "pa-0", attrs: { fluid: "" } },
        [
          _vm.loading
            ? _c(
                VRow,
                { staticClass: "mt-5", attrs: { justify: "center" } },
                [
                  _c(VProgressCircular, {
                    attrs: { indeterminate: "", color: "primary" },
                  }),
                ],
                1
              )
            : _vm.isDataEmpty
            ? _c(
                VRow,
                { staticClass: "mt-5", attrs: { justify: "center" } },
                [
                  _c(
                    VCol,
                    { staticClass: "text-center", attrs: { cols: "6" } },
                    [
                      _c("span", { staticClass: "subtitle-1 grey--text" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$tkey("emptyState")) +
                            "\n        "
                        ),
                      ]),
                    ]
                  ),
                ],
                1
              )
            : [
                _c(
                  VRow,
                  { staticClass: "mb-2", attrs: { align: "center" } },
                  [
                    _c(
                      VCol,
                      { staticClass: "ml-4 pr-2", attrs: { cols: "2" } },
                      [
                        _c(VTextField, {
                          staticClass: "inputs-actions__search",
                          attrs: {
                            flat: "",
                            dense: "",
                            "hide-details": "",
                            label: _vm.$t("actions.search"),
                            "single-line": "",
                            "append-icon": "mdi-magnify",
                          },
                          on: { input: _vm.debouncedFilterChange },
                          model: {
                            value: _vm.searchString,
                            callback: function ($$v) {
                              _vm.searchString = $$v
                            },
                            expression: "searchString",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("ag-grid-vue", {
                  staticClass:
                    "ag-theme-custom ag-theme-custom-stripped campaigns-grid",
                  style: { width: "100%", height: `${_vm.dataTableHeight}px` },
                  attrs: {
                    "grid-options": _vm.gridOptions,
                    "column-defs": _vm.columnDefs,
                    "row-data": _vm.rowData,
                  },
                  on: {
                    "grid-ready": _vm.onGridReady,
                    modelUpdated: _vm.onModelUpdated,
                  },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "campaigns-footer" }, [
                  _c("div", { staticClass: "campaigns-footer__meta" }, [
                    _c("div", { staticClass: "campaigns-footer__row-count" }, [
                      _c("span", { staticClass: "message" }, [
                        _vm._v("Rows: " + _vm._s(_vm.displayedRowCount)),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "campaigns-footer__msg-container" },
                      [
                        _vm.notAllDataOnDisplay
                          ? _c("span", { staticClass: "message" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("inputs.maxResultsShown", {
                                    limit: _vm.rowLimit,
                                  })
                                )
                              ),
                            ])
                          : _vm._e(),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "campaigns-footer__btn-container" },
                    [
                      _c(
                        VBtn,
                        {
                          staticClass: "grid-btn",
                          attrs: {
                            secondary: "",
                            small: "",
                            disabled: !_vm.hasPendingChanges || _vm.saving,
                            depressed: "",
                          },
                          on: { click: _vm.discardChanges },
                        },
                        [_vm._v(_vm._s(_vm.$t("actions.cancel")))]
                      ),
                      _vm._v(" "),
                      _c(
                        "tooltip",
                        {
                          staticClass: "save-tooltip",
                          attrs: {
                            value: _vm.saveDisabledTooltipMessage,
                            position: "bottom",
                            disabled: !_vm.saveDisabledTooltipMessage,
                          },
                        },
                        [
                          _c(
                            VBtn,
                            {
                              attrs: {
                                disabled: !_vm.saveAllowed,
                                loading: _vm.saving,
                                small: "",
                                color: "primary",
                                depressed: "",
                              },
                              on: { click: _vm.save },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.$t("actions.save")) +
                                  "\n              "
                              ),
                              _c(VIcon, { attrs: { small: "" } }, [
                                _vm._v("$import"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
              ],
        ],
        2
      ),
      _vm._v(" "),
      _vm.showUnsavedChangesDialog
        ? _c("unsaved-changes-dialog", {
            attrs: {
              "show-dialog": _vm.showUnsavedChangesDialog,
              "save-allowed": _vm.saveAllowed,
              "save-not-allowed-message":
                _vm.saveDisabledUnsavedChangesDialogMessage,
            },
            on: {
              closedUnsavedChangesDialog: _vm.handleUnsavedChangesDecision,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }